import React, { useEffect, useState } from "react";
import request from "../../../../Helpers/API";
import Swal from "sweetalert2";
import Switch from "@mui/material/Switch";
import { Button } from "@mui/material";
import { useHistory } from "react-router-dom";

const LineasPermisoScreen = ({ setMostrarMenu, idlinea, descripcion, idusuario }) => {
  const history = useHistory();
  const [usuarioLineas, setUsuarioLineas] = useState([]);
  const [permisosArray, setPermisosArray] = useState([]);

  const handleSwitchChange = (idlinea, idrel, isChecked) => {
    setUsuarioLineas((prevUsuarioLineas) =>
      prevUsuarioLineas.map((item) =>
        item.idlinea === idlinea ? { ...item, acceso: isChecked } : item
      )
    );

    const existingPermission = permisosArray.find(
      (permiso) => permiso.idlinea === idlinea
    );
    if (existingPermission) {
      setPermisosArray((prevPermisosArray) =>
        prevPermisosArray.map((permiso) =>
          permiso.idlinea === idlinea
            ? { ...permiso, estatus: isChecked }
            : permiso
        )
      );
    } else {
      setPermisosArray((prevPermisosArray) => [
        ...prevPermisosArray,
        { idlinea, idrel, idusuario, estatus: isChecked },
      ]);
    }
  };

  const confirmGuardar = async () => {
    const { value } = await Swal.fire({
      title: "Confirmar",
      text: `¿Desea modificar ${permisosArray.length} permisos?`,
      icon: "question",
      showCancelButton: true,
      cancelButtonText: "Cancelar",
      confirmButtonText: "Guardar",
      reverseButtons: true,
    });

    if (value) {
      // Usuario confirmó, realiza la acción
      onGuardar();
    } else {
      // Usuario canceló, borra todos los elementos de permisosArray
      history.push("/Permisos/PermisosUsuarios");
    }
  };

  const onGuardar = async () => {
    try {
      for (const post of permisosArray) {
        await request.post(`LineasVentasUsuarios`, post);
      }
      await Swal.fire({
        title: "MODIFICACION DE PERMISOS",
        text: "Permisos actualizados con éxito",
        icon: "success",
        customClass: {
          container: "mi-superpoop",
        },
      });
      //   history.push("/Permisos/PermisosUsuarios");
      setPermisosArray([]);
      onUpdate();
    } catch (error) {
      Swal.fire("PERMISOS", JSON.stringify(error), "error");
    }
  };

  const onCerrar = () => {
    setMostrarMenu(false);
  };

  const onUpdate = () => {
    request
      .get(
        `LineasVentasUsuarios/ListadoUsuarioLineasVenta?idusuario=${Number(
          idusuario
        )}&idlinea=${Number(idlinea)}`
      )
      .then((result) => {
        setUsuarioLineas(result);
      })
      .catch((error) => {
        Swal.fire("LISTADO USUARIOS-LINEASVENTA", JSON.stringify(error), "error");
      });
  };

  useEffect(() => {
    onUpdate();
  }, [idlinea]);

  const capitalizeWords = (str) => {
    return str
      ? str.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase())
      : "";
  };
  return (
    <div className="permisos-usuarios-menus-main-usuarios-screen-container">
      <div className="tabla-relacion-usuarios-menu scroll 4">
        <table>
          <thead>
            <tr>
              <th colSpan={2}>Linea {capitalizeWords(descripcion)}</th>
            </tr>
          </thead>

          <tbody>
            {usuarioLineas.map((item) => (
              <tr key={item.idlinea}>
                <td>{capitalizeWords(item.descripcion)}</td>
                <td>
                  <Switch
                    checked={item.acceso}
                    onChange={(event) =>
                      handleSwitchChange(
                        item.idlinea,
                        item.idrel,
                        event.target.checked
                      )
                    }
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="permisos-usuarios-agregar-permisos-menu-button-container">
        <Button variant="contained" color="error" onClick={() => onCerrar()}>
          Cerrar
        </Button>
        <Button variant="contained" onClick={() => confirmGuardar()}>
          Guardar
        </Button>
      </div>
    </div>
  );
};

export default LineasPermisoScreen;
